export default class FormCheckboxValidation {
  constructor() {
    this.$forms = $('form');
    this.$checkboxes = $('.checkbox input[data-val-ischecked]:visible', this.$forms);

    this.init();
  }

  init () {
    this.$checkboxes.each((index, checkbox) => {
      const errorMessage = $(checkbox).data('valIschecked');

      this.setValidationAttributes(checkbox, errorMessage);
    });
  }

  setValidationAttributes (checkbox, errorMessage) {
    $(checkbox)
      .attr('required', true)
      .attr('data-msg-required', errorMessage);
  }
}

